export function timeDateAsReadableString(datetime: string){
  const timestamp = new Date(Date.parse(datetime));
  return `${timestamp.getHours()}:${timestamp.getMinutes()}, ${timestamp.toDateString()}`
}